var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-file-upload-status"},[_c('div',{staticClass:"upload-status"},[_c('i',{staticClass:"fas",class:['upload-status-icon', _vm.iconClasses]}),_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }